import { Channel } from 'redux-saga';
import ISocketHandler from '../../../api/sockets/ISocketHandler';
import ISocketMessage from '../../../api/sockets/ISocketMessage';
import {
  serializeTicketLog,
  extendTicketLogWithPermissions,
} from '../../serializers/log';
import {
  ADD_LOG_ELEMENT_TO_TICKET_LOGS,
  UPDATE_TICKET_LOG_BY_WS,
} from '../../actions/log';
import { pickBy } from 'lodash';
import checkNullableValue from '../../../utils/checkNullableValue';

class TicketLogChannelHandler implements ISocketHandler {
  socketChannel: Channel<Record<string, unknown>>;

  currentManager: unknown;

  constructor({
    socketChannel,
    currentManager,
  }: {
    socketChannel: Channel<Record<string, unknown>>;
    currentManager: unknown;
  }) {
    this.socketChannel = socketChannel;
    this.currentManager = currentManager;
  }

  create(message: ISocketMessage): void {
    const { ticket_log: unparsedLog } = message.data;
    const serializedLog = serializeTicketLog(unparsedLog);
    const ticketLog = extendTicketLogWithPermissions({
      ticketLog: serializedLog,
      currentManager: this.currentManager,
    });

    this.socketChannel.put({
      type: ADD_LOG_ELEMENT_TO_TICKET_LOGS,
      payload: { ticketLog },
    });
  }

  update(message: ISocketMessage): void {
    const { ticket_log: unparsedLog } = message.data;
    const serializedLog = serializeTicketLog(unparsedLog);
    const updatedLogFields = pickBy(serializedLog, checkNullableValue);

    this.socketChannel.put({
      type: UPDATE_TICKET_LOG_BY_WS,
      payload: { ticketLog: updatedLogFields },
    });
  }

  delete(): void {
    return undefined;
  }

  info(): void {
    return undefined;
  }
}

export default TicketLogChannelHandler;
